import { decorateStapeRedirect } from './stapePurchase';

export const withConsentPilot = (url) => decorateStapeRedirect(
  typeof window !== "undefined" ? window.caConsent?.decorate(url) ?? url : url
);

export const runWithConsent = (category, callback) =>
  typeof window !== "undefined" && window.caConsent
    ? window.caConsent.run(category, callback)
    : Promise.resolve();
